module.exports = __webpack_public_path__ + "static/assets/a550579618ce2c7b9882834654598860.png";